var buttonLikeRoles = {
  button: true,
  menuitem: true
};
export default buttonLikeRoles;